module.exports = __webpack_public_path__ + "static/img/10.14a6d3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/sky101/10.png
// module id = EPrl
// module chunks = 1